import React, { useState, useEffect } from 'react';
import { Button, Col } from 'antd';
import { CodeOutlined } from '@ant-design/icons';
import { output } from '../_helpers';
import RequestButton from './RequestButton';
import { RequestPanelWrapper } from './index.style';
export default function RequestPanel(_ref) {
  var {
    outputAs,
    loading,
    isLoggedIn,
    handleNotLoggedIn,
    handleOutputClick
  } = _ref;
  var [buttonText, setButtonText] = useState('Make Request');
  var [buttonIcon, setButtonIcon] = useState( /*#__PURE__*/React.createElement(CodeOutlined, null));
  useEffect(() => {
    var outputConfig = output({
      data: {}
    })[outputAs]; // const { buttonText } = outputConfig.buttonText;

    setButtonText(outputConfig.buttonText);
    setButtonIcon(outputConfig.icon);
  }, [outputAs]);
  var requestButtonProps = {
    id: 'console-make-request',
    type: 'primary',
    htmlType: isLoggedIn ? 'submit' : 'button',
    icon: buttonIcon,
    block: true,
    loading,
    onClick: isLoggedIn ? null : handleNotLoggedIn,
    buttonText,
    handleOutputClick
  };
  return /*#__PURE__*/React.createElement(RequestPanelWrapper, null, /*#__PURE__*/React.createElement(RequestButton, requestButtonProps));
}